export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/people-7c922105877d59dda1f3c25ec66596d6.png";